import { useTinyHost } from "@tiny/host-contract";
import React from "react";
import {
  useGetAccountDeliverabilityQuery,
  useGetGlobalActiveEngagerSegmentQuery,
  usePutAccountDeliverabilityMutation,
} from "@tiny/api";
import { useQueryClient } from "react-query";

export function useGlobalActiveSegmentTab() {
  const { capabilities } = useTinyHost();
  const accountId = capabilities.accountId;
  const queryClient = useQueryClient();

  const { data: deliverabilityData, isLoading: isDeliverabilityLoading } =
    useGetAccountDeliverabilityQuery();

  const isEnabled =
    deliverabilityData?.enableGlobalActiveSegmentManagement ?? false;

  const { data: segmentRef, isLoading: isSegmentLoading } =
    useGetGlobalActiveEngagerSegmentQuery(accountId ?? "", {
      enabled: !!accountId && isEnabled,
    });

  const updateDeliverability = usePutAccountDeliverabilityMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["GET", "/account/deliverability"]);
    },
  });

  const handleToggleEnabled = React.useCallback(() => {
    updateDeliverability.mutate({
      data: { enableGlobalActiveSegmentManagement: !isEnabled },
    });
  }, [updateDeliverability, isEnabled]);

  return {
    isLoading: isDeliverabilityLoading || (isEnabled && isSegmentLoading),
    isEnabled,
    isToggling: updateDeliverability.isLoading,
    segmentId: segmentRef?.segmentId,
    handleToggleEnabled,
  };
}
